/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  let quizInitialized = false;
  
  function initFitGuideQuiz() {
    const popup = document.querySelector('.size-quiz-popup');
    if (!popup || quizInitialized) return;
    quizInitialized = true;
  
    const sizesStr = popup.dataset.quizSizes || '6,6.5,7,7.5,8,8.5,9,9.5,10,10.5,11,11.5,12,12.5,13,13.5';
    const widthsStr = popup.dataset.quizWidths || 'D (Standard),E (Wide),EEE (Extra Wide)';
    const sneakerSizes = sizesStr.split(',').map(s => s.trim());
    const widthOptions = widthsStr.split(',').map(w => w.trim());
  
    function decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }
  
    const translations = {
      step1: decodeHtml(popup.dataset.quizStep1 || "What's your usual sneaker size?"),
      step2: decodeHtml(popup.dataset.quizStep2 || "Do you usually wear wide-width footwear?"),
      step2No: decodeHtml(popup.dataset.quizStep2No || "No, I wear standard width"),
      step2Yes: decodeHtml(popup.dataset.quizStep2Yes || "Yes, I wear wide or extra-wide"),
      step3: decodeHtml(popup.dataset.quizStep3 || "What width do you typically wear?"),
      next: decodeHtml(popup.dataset.quizNext || "NEXT"),
      back: decodeHtml(popup.dataset.quizBack || "BACK"),
      seeSize: decodeHtml(popup.dataset.quizSeeSize || "SEE MY SIZE"),
      resultSize: decodeHtml(popup.dataset.quizResultSize || "Your <span class=\"highlighter\">Size</span> is"),
      resultRecommendation: decodeHtml(popup.dataset.quizResultRecommendation || "We recommend<br/>Size {{ size }} / Width {{ width }}"),
      resultLeo: decodeHtml(popup.dataset.quizResultLeo || "The Leo last runs a half-size large, so we've sized you down from your sneaker size."),
      resultContact: decodeHtml(popup.dataset.quizResultContact || "Still unsure? <a href=\"https://www.grantstoneshoes.com/pages/help-center?hcUrl=%2Fen-US%2Fcontact\" target=\"_blank\">Contact our team here</a>"),
      startOver: decodeHtml(popup.dataset.quizStartOver || "START OVER"),
      addCart: decodeHtml(popup.dataset.quizAddCart || "ADD TO CART"),
      result: decodeHtml(popup.dataset.quizResult || "RESULT")
    };
  
    let currentStep = 1;
    let selectedSneakerSize = null;
    let selectedWidthGroup = null;
    let selectedWidth = null;
  
    const steps = [
      { id: 1, label: "1/3", render: renderStep1 },
      { id: 2, label: "2/3", render: renderStep2 },
      { id: 3, label: "3/3", render: renderStep3 }
    ];
  
    function renderStep1() {
      return `
        <h2>${translations.step1}</h2>
        <div class="sizes-grid">
          ${sneakerSizes.map(size => `
            <button class="size-btn ${selectedSneakerSize == size ? 'active' : ''}" 
                    data-size="${size}">
              ${size}
            </button>
          `).join('')}
        </div>
      `;
    }
  
    function renderStep2() {
      return `
        <h2>${translations.step2}</h2>
        <div class="options-list">
          <button class="opt-btn ${selectedWidthGroup === 'no' ? 'active' : ''}" data-width="no">
            ${translations.step2No}
          </button>
          <button class="opt-btn ${selectedWidthGroup === 'yes' ? 'active' : ''}" data-width="yes">
            ${translations.step2Yes}
          </button>
        </div>
      `;
    }
  
    function renderStep3() {
      if (selectedWidthGroup !== "yes") return "";
  
      return `
        <h2>${translations.step3}</h2>
        <div class="options-list">
          ${widthOptions.map(w => `
            <button class="opt-btn ${selectedWidth === w ? 'active' : ''}" 
                    data-w="${w}">
              ${w}
            </button>
          `).join('')}
        </div>
      `;
    }
  
    function updateUI() {
      const content = popup.querySelector('.quiz-content');
      const nextBtn = popup.querySelector('.quiz-next');
      const backBtn = popup.querySelector('.quiz-back');
      const counter = popup.querySelector('.quiz-step-counter');
      const progressBar = popup.querySelector('.quiz-progress-bar');
  
      const step = steps.find(s => s.id === currentStep);
      counter.textContent = `${step.label}`;
  
      progressBar.style.width = ((currentStep / 3) * 100) + "%";
  
      content.innerHTML = step.render();
  
      backBtn.classList.toggle('hidden', currentStep === 1);
  
      const svgIcon = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 24 24"><path d="M6 12h12.5m0 0-6-6m6 6-6 6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
      
      if (currentStep === 2 && selectedWidthGroup === "no") {
        nextBtn.innerHTML = `${translations.seeSize} ${svgIcon}`;
      } else if (currentStep === 3) {
        nextBtn.innerHTML = `${translations.seeSize} ${svgIcon}`;
      } else {
        nextBtn.innerHTML = `${translations.next} ${svgIcon}`;
      }
  
      [...document.body.classList].forEach(c => {
        if (c.startsWith("quiz-step-")) document.body.classList.remove(c);
      });
      document.body.classList.remove('quiz-step-final');
      document.body.classList.add('quiz-step-' + currentStep);
      
      attachStepEvents();
    }
  
    function attachStepEvents() {
      document.querySelectorAll('.size-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          selectedSneakerSize = btn.dataset.size;
          updateUI();
        });
      });
  
      document.querySelectorAll('.opt-btn[data-width]').forEach(btn => {
        btn.addEventListener('click', () => {
          selectedWidthGroup = btn.dataset.width;
          selectedWidth = null;
          updateUI();
        });
      });
  
      document.querySelectorAll('.opt-btn[data-w]').forEach(btn => {
        btn.addEventListener('click', () => {
          selectedWidth = btn.dataset.w;
          updateUI();
        });
      });
    }
  
    function calculateResult() {
      const size = parseFloat(selectedSneakerSize);
  
      if (size === 13.5) {
        return { size: 13, width: selectedWidth || "D" };
      }
  
      if (size === 12.5) {
        return { size: 12, width: selectedWidth || "D" };
      }
  
      if (size === 13) {
        return { size: 12, width: "E" };
      }
  
      if (size <= 12) {
        const recommendedSize = size > 6 ? size - 0.5 : size;
        if (selectedWidthGroup === "no") {
          return { size: recommendedSize, width: "D" };
        }
  
        if (selectedWidth === "E (Wide)" || selectedWidth === "EE") {
          return { size: recommendedSize, width: "E" };
        }
  
        if (selectedWidth === "EEE (Extra Wide)") {
          return { size: recommendedSize, width: "EEE" };
        }
      }
  
      if (size === 13 && selectedWidthGroup === "no") {
        return { size: 12, width: "E" };
      }
  
      return { size: size, width: selectedWidth || "D" };
    }
  
    function showResult(leo) {
      const content = popup.querySelector('.quiz-content');
      const nav = popup.querySelector('.quiz-nav');
      const counter = popup.querySelector('.quiz-step-counter');
      const progressBar = popup.querySelector('.quiz-progress-bar');
  
      const r = calculateResult();
      const productImage = document.querySelector('.product__images .product__photo img');
      const imageSrc = productImage ? productImage.getAttribute('src') : '';
  
      counter.textContent = translations.result;
      progressBar.style.width = "100%";
  
      const recommendationText = translations.resultRecommendation
        .replace('{{ size }}', r.size)
        .replace('{{ width }}', r.width);
  
      content.innerHTML = `
        <h4>${translations.resultSize}</h4>
        ${imageSrc ? `<img src="${imageSrc}"/>` : ''}
        <h2 class="result-heading">${recommendationText}</h2>
        ${leo ? `
          <p class="subtext">
            ${translations.resultLeo}
          </p>
        ` : `
          <p class="subtext">
            ${translations.resultContact}
          </p>
        `}
        <div class="quiz-nav-result">
          <button class="quiz-restart btn btn--small">
            <svg width="50px" height="50px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
              <path d="M25 38c-7.2 0-13-5.8-13-13 0-3.2 1.2-6.2 3.3-8.6l1.5 1.3C15 19.7 14 22.3 14 25c0 6.1 4.9 11 11 11 1.6 0 3.1-.3 4.6-1l.8 1.8c-1.7.8-3.5 1.2-5.4 1.2z"/>
              <path d="M34.7 33.7l-1.5-1.3c1.8-2 2.8-4.6 2.8-7.3 0-6.1-4.9-11-11-11-1.6 0-3.1.3-4.6 1l-.8-1.8c1.7-.8 3.5-1.2 5.4-1.2 7.2 0 13 5.8 13 13 0 3.1-1.2 6.2-3.3 8.6z"/>
              <path d="M18 24h-2v-6h-6v-2h8z"/>
              <path d="M40 34h-8v-8h2v6h6z"/>
            </svg>
            ${translations.startOver}
          </button>
          <button class="quiz-add-to-cart btn--solid btn btn--small btn--primary">
            ${translations.addCart}
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 24 24">
              <path d="M6 12h12.5m0 0-6-6m6 6-6 6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
      `;
  
      [...document.body.classList].forEach(c => {
        if (c.startsWith("quiz-step-")) document.body.classList.remove(c);
      });
      document.body.classList.add('quiz-step-final');
      nav.style.display = "none";
  
      popup.querySelector('.quiz-restart').addEventListener('click', () => {
        currentStep = 1;
        selectedSneakerSize = null;
        selectedWidthGroup = null;
        selectedWidth = null;
        nav.style.display = "flex";
        updateUI();
      });
  
      popup.querySelector('.quiz-add-to-cart').addEventListener('click', () => {
        const targetSize = String(r.size).trim();
        const targetWidth = r.width ? r.width.split(' (')[0].trim() : null;
        const targetWidthFull = r.width ? String(r.width).trim() : null;
        
        function findOptionInput(value) {
          const inputs = document.querySelectorAll('input[data-single-option-selector]');
          const exactMatches = [];
          const numericMatches = [];
          const partialMatches = [];
          
          const valueNum = parseFloat(value);
          const isNumeric = !isNaN(valueNum) && isFinite(valueNum);
          
          for (const input of inputs) {
            const inputValue = String(input.value).trim();
            
            if (inputValue === value) {
              exactMatches.push(input);
              continue;
            }
            
            if (isNumeric) {
              const inputNum = parseFloat(inputValue);
              if (!isNaN(inputNum) && isFinite(inputNum) && valueNum === inputNum) {
                numericMatches.push(input);
                continue;
              }
            }
            
            if (inputValue.includes(value) || value.includes(inputValue)) {
              if (!isNumeric) {
                partialMatches.push(input);
              }
            }
          }
          
          if (exactMatches.length > 0) return exactMatches[0];
          if (numericMatches.length > 0) return numericMatches[0];
          if (partialMatches.length > 0) return partialMatches[0];
          
          return null;
        }
  
        const sizeInput = targetSize ? findOptionInput(targetSize) : null;
        const widthInput = (targetWidth && findOptionInput(targetWidth)) || 
                          (targetWidthFull && findOptionInput(targetWidthFull)) || null;
  
        if (!sizeInput) {
          alert('Could not find matching product size. Please select manually.');
          return;
        }
  
        const optionsToSelect = [sizeInput];
        if (widthInput && widthInput !== sizeInput) {
          optionsToSelect.push(widthInput);
        }
  
        optionsToSelect.sort((a, b) => {
          const aIndex = parseInt(a.getAttribute('data-index')?.replace('option', '') || '0');
          const bIndex = parseInt(b.getAttribute('data-index')?.replace('option', '') || '0');
          return aIndex - bIndex;
        });
  
        const variantIdInput = document.querySelector('input[name="id"][form]');
        if (!variantIdInput) return;
  
        const initialVariantId = variantIdInput.value;
        let selectedCount = 0;
  
        optionsToSelect.forEach((input, idx) => {
          setTimeout(() => {
            input.checked = true;
            input.click();
            input.dispatchEvent(new Event('change', { bubbles: true }));
            
            selectedCount++;
            
            if (selectedCount === optionsToSelect.length) {
              let checkCount = 0;
              const maxChecks = 30;
              
              const checkVariant = () => {
                checkCount++;
                const currentVariantId = variantIdInput.value;
                
                if (currentVariantId !== initialVariantId && currentVariantId) {
                  const addToCartBtn = document.querySelector('product-form [data-add-to-cart]');
                  if (addToCartBtn && !addToCartBtn.disabled) {
                    document.dispatchEvent(
                      new CustomEvent('theme:cart:add', {
                        detail: { button: addToCartBtn },
                        bubbles: false
                      })
                    );
                  }
                  
                  popup.classList.remove('active');
                  currentStep = 1;
                  selectedSneakerSize = null;
                  selectedWidthGroup = null;
                  selectedWidth = null;
                  nav.style.display = "flex";
                  updateUI();
                } else if (checkCount < maxChecks) {
                  setTimeout(checkVariant, 100);
                } else {
                  alert('Failed to update product variant. Please try selecting options manually.');
                }
              };
              
              setTimeout(checkVariant, 300);
            }
          }, idx * 150);
        });
      });
    }
  
    const nextBtn = popup.querySelector('.quiz-next');
    const backBtn = popup.querySelector('.quiz-back');
  
    nextBtn.addEventListener('click', () => {
      if (currentStep === 1 && !selectedSneakerSize) return;
      if (currentStep === 2 && !selectedWidthGroup) return;
      if (currentStep === 3 && selectedWidthGroup === "yes" && !selectedWidth) return;
  
      if (currentStep === 2 && selectedWidthGroup === "no") {
        return showResult(true);
      }
  
      if (currentStep === 3) {
        return showResult(false);
      }
  
      currentStep++;
      updateUI();
    });
  
    backBtn.addEventListener('click', () => {
      if (currentStep > 1) {
        currentStep--;
        updateUI();
      }
    });
  
    const closeBtn = popup.querySelector('.quiz-close');
    const overlay = popup.querySelector('.quiz-overlay');
  
    closeBtn.addEventListener('click', () => {
      popup.classList.remove('active');
      const restartBtn = popup.querySelector('.quiz-restart');
      if (restartBtn) restartBtn.click();
    });
  
    overlay.addEventListener('click', () => {
      popup.classList.remove('active');
      const restartBtn = popup.querySelector('.quiz-restart');
      if (restartBtn) restartBtn.click();
    });
    
    popup._updateUI = updateUI;
  }
  
  document.body.addEventListener('click', e => {
    if (e.target.classList.contains('trigger-quiz-popup')) {
      const popup = document.querySelector('.size-quiz-popup');
      if (popup) {
        if (!quizInitialized) {
          initFitGuideQuiz();
        }
        popup.classList.add('active');
        if (popup._updateUI) {
          popup._updateUI();
        }
      }
    }
  });
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFitGuideQuiz);
  } else {
    initFitGuideQuiz();
  }




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

